module.exports = __webpack_public_path__ + "img/portfolio-paper.840573cb.png";